<template>
  <div
    class="datetime-field"
    :class="{ 'datetime-field-disabled': disabled }"
    @click="openPicker"
  >
    <b-form-input
      ref="input"
      :value="value"
      :type="type"
      :lang="type === 'time' ? 'en-GB' : undefined"
      class="datetime-input"
      :required="required"
      :disabled="disabled"
      @input="$emit('input', $event)"
    />
    <span class="datetime-icon" aria-hidden="true">
      <b-icon-calendar v-if="type === 'date'" />
      <b-icon-clock v-else />
    </span>
  </div>
</template>

<script>
export default {
  name: 'DatetimeInput',
  props: {
    value: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'date',
      validator: function (v) {
        return v === 'date' || v === 'time'
      },
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getInputEl() {
      var ref = this.$refs.input
      return ref && ref.$el ? ref.$el : null
    },

    openPicker() {
      if (this.disabled) return
      var input = this.getInputEl()
      if (!input) return

      try {
        if (input.selectionStart !== input.selectionEnd) return
      } catch (e) {
        // date/time inputs don't support selectionStart in some browsers
      }

      input.focus()

      if (typeof input.showPicker === 'function') {
        try {
          input.showPicker()
        } catch (e) {
          // showPicker can throw if already open or unsupported
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.datetime-field {
  position: relative;
  cursor: pointer;

  &.datetime-field-disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
}

.datetime-input {
  position: relative;
  font-size: 13px;
  height: 42px;
  border-radius: 10px;
  border-color: #d8e0ea;
  color: #111827;
  padding-right: 26px;
  cursor: pointer;

  &:focus {
    border-color: #087ff5;
    box-shadow: 0 0 0 3px rgba(8, 127, 245, 0.12);
    cursor: text;
  }

  &::-webkit-calendar-picker-indicator {
    position: absolute;
    right: 0;
    top: 0;
    width: 28px;
    height: 100%;
    margin: 0;
    padding: 0;
    opacity: 0;
    cursor: pointer;
  }
}

/* Time values render as "12:30 AM" (Chromium ignores the lang attr and
   follows the OS locale), which is wider than a date — compact the text and
   padding so the AM/PM suffix fits even in narrow grid cells. The min-width
   is a hard floor: Safari/WebKit's native time control (iPad included)
   doesn't reflow its own AM/PM segment to fit a narrower box the way
   Chromium does — below this it visually clips to "5:15p" instead of
   "5:15 PM" regardless of font-size/padding. Callers laying this out in a
   narrow grid (see SupervisorWorkerCards' .mobile-day-inputs) size their
   track to match rather than fight this floor. */
input[type='time'].datetime-input {
  font-size: 13px;
  padding-left: 8px;
  padding-right: 22px;
  min-width: 148px;
}

.datetime-icon {
  position: absolute;
  right: 7px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  color: #9ca3af;
  font-size: 13px;
}
</style>
